// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-container[data-v-d42f4840]{width:100%;position:relative}#timeline-cancel-fullscreen-panel[data-v-d42f4840]{display:inline-block;width:50px;line-height:65px;height:50px;cursor:pointer;text-align:center;background-color:rgba(0,0,20,0.7);z-index:1024;position:fixed;right:15px;top:15px;border-radius:5px}#timeline-cancel-fullscreen-panel__collapse-icon[data-v-d42f4840]{color:white;font-size:35px}\n", ""]);
// Exports
module.exports = exports;
